import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import "./index.css";

export default function HomePopup({ onClose, title, image, link }) {
  return (
    <motion.div
      className="backdrop"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="modal"
        initial={{ scale: 0.8, y: 30 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.8, y: 30 }}
      >
        <div className="close">
          <div onClick={onClose}>
            <span className="material-icons close-icon">close</span>
          </div>
        </div>
        <Link to={link}>
          <img src={image} alt={title} />
        </Link>
      </motion.div>
    </motion.div>
  );
}
